// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2yxRP","header":"ClearentDisclaimer_header__1Kuws","inner":"ClearentDisclaimer_inner__72dxK"};